import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import FlexDivider from './FlexDivider';
import ClientProvider from './client';
export default createDemo(import.meta.url, FlexDivider, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/dividers/demos/flex/FlexDivider.tsx",
    "fileName": "FlexDivider.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import FormatBoldIcon from '@mui/icons-material/FormatBold';\nimport FormatItalicIcon from '@mui/icons-material/FormatItalic';\nimport Box from '@mui/material/Box';\nimport Divider from '@mui/material/Divider';\n\nexport default function FlexDivider() {\n  return (\n    <Box\n      sx={{\n        display: 'inline-flex',\n        alignItems: 'center',\n        border: '1px solid',\n        borderColor: 'divider',\n        borderRadius: 2,\n        bgcolor: 'background.paper',\n        color: 'text.secondary',\n        '& svg': {\n          m: 1,\n        },\n      }}\n    >\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <FormatBoldIcon />\n      <Divider orientation=\"vertical\" variant=\"middle\" flexItem />\n      <FormatItalicIcon />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 27,
        "focusedLines": 3,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import FormatBoldIcon from '@mui/icons-material/FormatBold';\nimport FormatItalicIcon from '@mui/icons-material/FormatItalic';\nimport Box from '@mui/material/Box';\nimport Divider from '@mui/material/Divider';\n\nexport default function FlexDivider() {\n  return (\n    <Box\n      sx={{\n        display: 'inline-flex',\n        alignItems: 'center',\n        border: '1px solid',\n        borderColor: 'divider',\n        borderRadius: 2,\n        bgcolor: 'background.paper',\n        color: 'text.secondary',\n        '& svg': {\n          m: 1,\n        },\n      }}\n    >\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <FormatBoldIcon />\n      <Divider orientation=\"vertical\" variant=\"middle\" flexItem />\n      <FormatItalicIcon />\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "FormatBoldIcon"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Divider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "orientation"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "vertical",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "middle",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "flexItem"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "FormatItalicIcon"
              ],
              " />"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 27,
    "focusedLines": 3,
    "collapsible": true,
    "externals": [
      "@mui/icons-material/FormatBold",
      "@mui/icons-material/FormatItalic",
      "@mui/material/Box",
      "@mui/material/Divider"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
